import styled from '@emotion/styled'
import React, { useRef} from 'react'
import useScrollIntoView from '../hooks/useScrollIntoVIew'
import {PALETTE} from '../styles/paletteV3'
import {NavSidebar} from '../types/constEnums'

const lineHeight = NavSidebar.SUB_LINE_HEIGHT










const ItemRoot = styled('div')(
  ({isActive, isComplete, isDisabled, isDragging, onClick}) => ({
    alignItems: 'center',
    backgroundColor: isActive ? PALETTE.SLATE_200 : isDragging ? PALETTE.SLATE_100 : 'transparent',
    borderRadius: '0 4px 4px 0',
    color: PALETTE.SLATE_700,
    display: 'flex',
    flexShrink: 0,
    fontSize: 14,
    fontWeight: 400,
    minHeight: 40,
    opacity: !isActive && isComplete ? 0.5 : undefined,
    padding: '8px 0',
    position: 'relative',
    userSelect: 'none',
    width: '100%',
    '&:hover': {
      backgroundColor: onClick && !isActive ? PALETTE.SLATE_200 : undefined,
      cursor: !isActive && onClick ? 'pointer' : undefined,
      opacity: !isDisabled ? 1 : undefined
    }
  }),
  ({isUnsyncedFacilitatorStage}) =>
    isUnsyncedFacilitatorStage && {
      color: PALETTE.ROSE_500,
      opacity: 1
    }
)

const ItemLabel = styled('div')(({isComplete}) => ({
  color: 'inherit',
  fontSize: NavSidebar.SUB_FONT_SIZE,
  flex: 1,
  paddingLeft: 56,
  textDecoration: isComplete ? 'line-through' : undefined,
  wordBreak: 'break-word',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'pre'
}))

const ItemMeta = styled('div')({
  alignItems: 'center',
  alignContent: 'center',
  display: 'flex',
  height: lineHeight,
  paddingLeft: 4
})












const MeetingSubnavItem = (props) => {
  const {
    isActive,
    isComplete,
    isDisabled,
    isDragging,
    isUnsyncedFacilitatorStage,
    children,
    metaContent,
    onClick
  } = props
  const ref = useRef(null)
  useScrollIntoView(ref, isActive)
  return (
    React.createElement(ItemRoot, {
      ref: ref,
      isActive: isActive,
      isComplete: isComplete,
      isDisabled: isDisabled,
      isDragging: isDragging,
      isUnsyncedFacilitatorStage: isUnsyncedFacilitatorStage,
      onClick: !isDisabled ? onClick : undefined,}

      , React.createElement(ItemLabel, { isComplete: isComplete,}, children)
      , React.createElement(ItemMeta, null, metaContent)
    )
  )
}

export default MeetingSubnavItem
